import { Component, OnInit } from '@angular/core';
import { KpiScorecardService } from '../../services/kpi-scorecard.service';
import { ToastService } from '../../../shared/services/toast.service';
import {
    KPIScorecard,
    ClientKPIScorecard,
    ClientKPIScorecardStaffPosition,
    IScorecardKPIInfo,
    IKPIScorecardChangeUpsertParams,
} from './kpi-scorecard-models';
import { forkJoin } from 'rxjs';
import {
    UntypedFormGroup,
    UntypedFormBuilder,
    Validators,
    UntypedFormControl,
} from '@angular/forms';
import { EmployeePositionService, StaffPosition } from '../../services/employee-position.service';
import {
    ClientKPIConfigWebModel,
    ClientKPIWebModelComplete,
    MilestoneStaffingMap,
    PositionMap,
} from '../../../shared/interfaces/kpi-data';
import { KPIService } from '../../../shared/services/kpi.service';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import {
    NoDataActionType,
    NoDataSourceType,
    NoDataTypes,
} from 'app/modules/shared/interfaces/no-data';
import { ITableColumns } from '../../../reports/interfaces/reporting-data';
import {
    IDataChange,
    ITableColumnProperties,
    ITableDataProperties,
} from '../../../shared/components/common-kendo-table/common-kendo-table.component';
import { CommonKendoTableService } from '../../../shared/services/common-kendo-table.service';
import {
    ICellClickEventInfo,
    ICustomTableInfoExtend,
    IFooterObject,
} from 'app/modules/shared/components/custom-mat-table/custom-mat-table.component';
import { ReportingService } from 'app/modules/reports/services/reporting.service';
@Component({
    selector: 'app-kpi-scorecard',
    templateUrl: './kpi-scorecard.component.html',
    styleUrls: ['./kpi-scorecard.component.scss'],
})
export class KpiScorecardComponent implements OnInit {
    tabs = [{ label: 'Employees' }, { label: 'Partners' }];
    kpiScorecards: KPIScorecard[];
    clientKPIScorecards: ClientKPIScorecard[];
    clientKPIScorecardStaffPositions: ClientKPIScorecardStaffPosition[];
    staffPositions: StaffPosition[];
    scorecardListView: boolean;
    selectedKPIScorecard: KPIScorecard;
    selectDatesAndPositions: boolean;
    scorecardForm: UntypedFormGroup;
    config: ClientKPIConfigWebModel;
    kpiMasterList: IScorecardKPIInfo[];
    selectedPositionKeys = new Set();
    selectKPIs: boolean;
    setKPIWeights: boolean;
    viewKPIs: boolean;
    weightEqual100: boolean;
    totalWeightPercentage: number = 0;
    kpiMilestoneStaffingKeyMap: MilestoneStaffingMap[];
    viewKPIScorecardProfile: boolean;
    loading: boolean = true;
    gridView: GridDataResult;
    scorecardInfoData: IScorecardKPIInfo[];
    scorecardInfoDataOriginal: IScorecardKPIInfo[];
    sort: SortDescriptor[] = [
        {
            field: 'kpiScorecard',
            dir: 'asc',
        },
    ];
    sortable = {
        mode: 'single',
        allowUnsort: false,
    };
    noDataType: NoDataTypes;
    positionMap: PositionMap[];
    summaryTableColumnProperties: ITableColumnProperties;
    summaryTableDataProperties: ITableDataProperties;
    profileTableColumnProperties: ITableColumnProperties;
    profileTableDataProperties: ITableDataProperties;
    action: NoDataActionType;
    changedProileData: IScorecardKPIInfo[];
    searchTerm: string;
    checkedStaffPositions = new Set();
    columnInfoList: ITableColumns[];
    customTableInfo: ICustomTableInfoExtend;
    footerObject: IFooterObject;

    constructor(
        private scorecardService: KpiScorecardService,
        private toast: ToastService,
        private kpiService: KPIService,
        private formBuilder: UntypedFormBuilder,
        private positionService: EmployeePositionService,
        private reusableFunctions: ReusableFunctions,
        private commKendoTbleService: CommonKendoTableService,
        private reportService: ReportingService
    ) {}

    ngOnInit() {
        this.action = NoDataActionType.pageStart;
        this.searchTerm = '';
        this.noDataType = {
            action: NoDataActionType.pageStart,
            searchTerm: this.searchTerm,
            componentTitle: 'KPI',
            inputSource: NoDataSourceType.table,
        };

        scroll(0, 0);
        this.scorecardInfoData = [];
        this.changedProileData = [];
        this.scorecardListView = true;
        this.viewKPIScorecardProfile = false;
        this.scorecardForm = this.createFormGroup();
        this.initiateTableProperties();
        this.getKPIScorecardData();
        this.getClientKPIData();

        this.setProfileSummaryTableParams();
        this.setKpiProfileTablesParams();
    }

    initiateTableProperties() {
        this.columnInfoList = [
            {
                fieldId: 'isSelected',
                fieldName: '',
                isHyperlink: false,
                fieldOrder: 0,
                isSortable: true,
                headerAlignment: 'centre',
                dataAlignment: 'centre',
                dataType: 'input',
                dataInputProperties: {
                    dataInputType: 'checkbox',
                    key: 'isSelected',
                    valueKey: '',
                    disableKey: 'isSelectedColumnDisableKey',
                    isCellDependentDdl: false,
                    widthPercent: 70,
                    descriptionKey: '',
                },
                width: 50,
                filterable: false,
                checkBoxProperties: {
                    checked: false,
                    disabled: false,
                    title: '',
                },
                hidden: false,
            },
            {
                fieldId: 'clientKPIDescription',
                fieldName: 'KEY PERFORMANCE INDICATOR',
                isHyperlink: false,
                fieldOrder: 0.5,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                dataType: 'string',
                width: 250,
                filterable: false,
                filter: 'text',
                allowSearch: true,
            },
            {
                fieldId: 'scorecardWeight',
                fieldName: 'WEIGHT',
                isHyperlink: false,
                fieldOrder: 1,
                isSortable: true,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'input',
                decimalPlaces: 1,
                width: 120,
                filterable: false,
                filter: 'text',
                aggregationTitle: 'Total: ',
                aggregationType: 'sum',
                dataInputProperties: {
                    dataInputType: 'textInput',
                    key: 'scorecardWeight',
                    valueKey: '',
                    disableKey: 'weightColumnDisableKey',
                    errorKey: '',
                    isCellDependentDdl: false,
                    widthPercent: 40,
                    textInputType: 'number',
                },
                hidden: false,
                allowSearch: true,
                hideFooterValue: true,
                label: '%',
            },
            {
                fieldId: 'targetFormatted',
                fieldName: 'TARGET',
                isHyperlink: false,
                fieldOrder: 1.5,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 1,
                width: 120,
                filterable: false,
                filter: 'text',
                allowSearch: true,
            },
            {
                fieldId: 'poor',
                fieldName: 'POOR',
                fieldOrder: 2,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                hideIf: 'excel',
                backgroundDefaultColor: '#fddbdb',
                backgroundColorThresholdFileldId: 'poor',
                headerBackgroundColor: '#fddbdb',
                allowSearch: true,
            },
            {
                fieldId: 'fair',
                fieldName: 'FAIR',
                fieldOrder: 3,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                backgroundDefaultColor: '#fff9e7',
                backgroundColorThresholdFileldId: 'fair',
                headerBackgroundColor: '#fff9e7',
                allowSearch: true,
            },
            {
                fieldId: 'good',
                fieldName: 'GOOD',
                isHyperlink: false,
                fieldOrder: 4,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                hideIf: 'excel',
                backgroundDefaultColor: '#e0f3f3',
                backgroundColorThresholdFileldId: 'good',
                headerBackgroundColor: '#e0f3f3',
                allowSearch: true,
            },
            {
                fieldId: 'veryGood',
                fieldName: 'VERY GOOD',
                isHyperlink: false,
                isHierarchyEntity: false,
                fieldOrder: 5,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                backgroundDefaultColor: '#f7efff',
                backgroundColorThresholdFileldId: 'veryGood',
                headerBackgroundColor: '#f7efff',
                allowSearch: true,
            },
            {
                fieldId: 'excellent',
                fieldName: 'EXCELLENT',
                isHyperlink: false,
                fieldOrder: 6,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                hideIf: 'excel',
                backgroundDefaultColor: '#f3f9ed',
                backgroundColorThresholdFileldId: 'excellent',
                headerBackgroundColor: '#f3f9ed',
                allowSearch: true,
            },
        ];

        this.customTableInfo = {
            tableId: 'kpi-edit',
            tableHeight: 700,
            hasData: false,
            isDataReady: false,
            columnInfoList: this.columnInfoList,
            dataSet: [],
            searchTerm: '',
            action: NoDataActionType.pageStart,
            title: '',
            bandColorList: [],
            dataHandleInUiSide: true,
            showSummary: true,
        };
    }

    setProfileSummaryTableParams() {
        this.summaryTableDataProperties = {
            action: this.action,
            gridData: [],
            searchTerm: '',
            componentTitle: '',
            initialPageSize: 500,
            initialSkip: 0,
            maxHeight: 700,
            recordSelection: [],
            kendoGridSelectById: '',
            hasData: false,
            isDataLoaded: false,
            class: 'common-kendo-table-no-box-shadow',
            pageable: false,
            useLGScroll: false,
        };

        let summaryTableColumnProperties: ITableColumns[] = [
            {
                fieldId: 'kpiScorecard',
                fieldName: 'SCORECARD',
                isHyperlink: false,
                fieldOrder: 0,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                dataType: 'string',
                width: 150,
                filterable: false,
            },
            {
                fieldId: 'positions',
                fieldName: 'Positions',
                isHyperlink: false,
                fieldOrder: 1,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                dataType: 'string',
                width: 200,
                filterable: false,
            },
            {
                fieldId: 'numKPIs',
                fieldName: '# KPIS',
                isHyperlink: false,
                fieldOrder: 2,
                isSortable: true,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'number',
                width: 60,
                filterable: false,
            },
            {
                fieldId: 'numEmployees',
                fieldName: '# ASSIGNED',
                isHyperlink: false,
                fieldOrder: 3,
                isSortable: true,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'number',
                width: 80,
                filterable: false,
            },
            {
                fieldId: 'effectiveDate',
                fieldName: 'EFFECTIVE',
                isHyperlink: false,
                fieldOrder: 4,
                isSortable: true,
                headerAlignment: 'centre',
                dataAlignment: 'centre',
                dataType: 'date',
                width: 90,
                filterable: false,
            },
            {
                fieldId: 'inActiveDate',
                fieldName: 'INACTIVE',
                isHyperlink: false,
                fieldOrder: 5,
                isSortable: true,
                headerAlignment: 'centre',
                dataAlignment: 'centre',
                dataType: 'date',
                width: 90,
                filterable: false,
            },
            {
                fieldId: 'edit',
                fieldName: '',
                isHyperlink: false,
                fieldOrder: 6,
                isSortable: false,
                headerAlignment: 'centre',
                dataAlignment: 'centre',
                dataType: 'icon',
                width: 50,
                filterable: false,
                iconProperties: {
                    iconClass: 'far fa-pencil-alt',
                },
            },
        ];

        this.summaryTableColumnProperties = {
            columnProperties: summaryTableColumnProperties,
        };
    }

    setKpiProfileTablesParams() {
        this.profileTableDataProperties = {
            action: this.action,
            gridData: [],
            searchTerm: this.searchTerm,
            componentTitle: '',
            initialPageSize: 500,
            initialSkip: 0,
            maxHeight: 700,
            recordSelection: [],
            kendoGridSelectById: '',
            hasData: false,
            isDataLoaded: false,
            class: 'common-kendo-table-no-box-shadow',
            pageable: false,
            useLGScroll: false,
        };

        let profileTableColumnProperties: ITableColumns[] = [
            {
                fieldId: 'isSelected',
                fieldName: '',
                isHyperlink: false,
                fieldOrder: 0,
                isSortable: true,
                headerAlignment: 'centre',
                dataAlignment: 'centre',
                dataType: 'input',
                dataInputProperties: {
                    dataInputType: 'checkbox',
                    key: '',
                    valueKey: '',
                    isCellDependentDdl: false,
                    widthPercent: 50,
                },
                width: 50,
                filterable: false,
                checkBoxProperties: {
                    checked: false,
                    disabled: false,
                    title: '',
                },
                hidden: true,
            },
            {
                fieldId: 'clientKPIDescription',
                fieldName: 'KEY PERFORMANCE INDICATOR',
                isHyperlink: false,
                fieldOrder: 0.5,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                dataType: 'string',
                width: 250,
                filterable: false,
                filter: 'text',
                allowSearch: true,
            },
            {
                fieldId: 'scorecardWeight',
                fieldName: 'WEIGHT',
                isHyperlink: false,
                fieldOrder: 1,
                isSortable: true,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'input',
                decimalPlaces: 1,
                width: 120,
                filterable: false,
                filter: 'text',
                aggregationTitle: 'Total: ',
                aggregationType: 'sum',
                inputProperties: {
                    style: {
                        width: '70px',
                        height: '57px',
                    },
                    type: 'number',
                },
                hidden: false,
                allowSearch: true,
                hideFooterValue: true,
                label: '%',
            },
            {
                fieldId: 'targetFormatted',
                fieldName: 'TARGET',
                isHyperlink: false,
                fieldOrder: 1.5,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 1,
                width: 120,
                filterable: false,
                filter: 'text',
                allowSearch: true,
            },
            {
                fieldId: 'poor',
                fieldName: 'POOR',
                fieldOrder: 2,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                hideIf: 'excel',
                columnBackgroundColor: '#fddbdb',
                headerBackgroundColor: '#fddbdb',
                allowSearch: true,
            },
            {
                fieldId: 'fair',
                fieldName: 'FAIR',
                fieldOrder: 3,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                columnBackgroundColor: '#fff9e7',
                headerBackgroundColor: '#fff9e7',
                allowSearch: true,
            },
            {
                fieldId: 'good',
                fieldName: 'GOOD',
                isHyperlink: false,
                fieldOrder: 4,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                hideIf: 'excel',
                columnBackgroundColor: '#e0f3f3',
                headerBackgroundColor: '#e0f3f3',
                allowSearch: true,
            },
            {
                fieldId: 'veryGood',
                fieldName: 'VERY GOOD',
                isHyperlink: false,
                isHierarchyEntity: false,
                fieldOrder: 5,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                columnBackgroundColor: '#f7efff',
                headerBackgroundColor: '#f7efff',
                allowSearch: true,
            },
            {
                fieldId: 'excellent',
                fieldName: 'EXCELLENT',
                isHyperlink: false,
                fieldOrder: 6,
                isSortable: false,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'string',
                decimalPlaces: 0,
                width: 120,
                filterable: false,
                hideIf: 'excel',
                columnBackgroundColor: '#f3f9ed',
                headerBackgroundColor: '#f3f9ed',
                allowSearch: true,
            },
        ];

        this.profileTableColumnProperties = {
            columnProperties: profileTableColumnProperties,
        };
    }

    getKPIScorecardData() {
        this.loading = true;
        forkJoin([
            this.scorecardService.getKPIScorecards(),
            this.scorecardService.getClientKPIScorecards(),
            this.positionService.getPositions(),
            this.scorecardService.getClientKPIScorecardStaffPositions(),
            this.kpiService.getKPIAssignedCounts(),
        ]).subscribe(
            ([scorecards, clientScorecards, positions, scorecardStaffPositions, positionMap]) => {
                if (positions && positions.length) {
                    this.staffPositions = positions;
                } else {
                    this.toast.warning('No staff positions found.');
                }

                if (positionMap && positionMap.length) {
                    this.positionMap = positionMap;
                }
                if (scorecards && scorecards.length) {
                    this.kpiScorecards = scorecards;
                    this.gridView = {
                        data: orderBy(scorecards, this.sort),
                        total: scorecards.length,
                    };
                    this.updateSummaryGrid();

                    if (
                        clientScorecards &&
                        clientScorecards.length &&
                        scorecardStaffPositions &&
                        scorecardStaffPositions.length
                    ) {
                        this.clientKPIScorecards = clientScorecards;
                        this.clientKPIScorecardStaffPositions = scorecardStaffPositions;
                        this.setKPIScorecardsAssignedAndPositions();
                    } else {
                        //no client scorecards found
                    }
                } else {
                    //no scorecards
                    this.toast.error('No scorecards found.');
                }

                this.loading = false;
            },
            (error) => {
                this.loading = false;
                throw new Error(error);
            }
        );
    }

    updateSummaryGrid() {
        this.summaryTableColumnProperties = Object.assign({}, this.summaryTableColumnProperties);
        this.summaryTableDataProperties.gridData = this.kpiScorecards;
        this.summaryTableDataProperties.hasData = this.kpiScorecards.length > 0;
        this.summaryTableDataProperties.isDataLoaded = true;
        this.summaryTableDataProperties = Object.assign({}, this.summaryTableDataProperties);
    }

    searchSummaryGrid(summarySearchTerm) {
        this.gridView.data = this.kpiScorecards.filter((x) =>
            x.kpiScorecard.toLowerCase().includes(summarySearchTerm.toLowerCase())
        );
        this.sortChange(this.sort);
    }

    getClientKPIData() {
        forkJoin([
            this.kpiService.getCurrentKPIConfiguration(),
            this.kpiService.getKPIMasterList(),
            this.kpiService.getKPIMilestoneStaffingKeyMap(),
        ]).subscribe(([config, list, staffMap]) => {
            this.kpiMasterList = list;
            if (staffMap && staffMap.length) {
                this.kpiMilestoneStaffingKeyMap = staffMap;
            } else {
                this.toast.warning('Could not retrieve staff map.');
            }
            if (this.kpiMasterList.length === 0) {
                this.toast.error('There was a problem retrieving KPIs.');
                return;
            }
            if (config && config.clientKPIData && config.clientKPIData.length) {
                //client has configured KPIs
                this.config = config;
                //this.sortKPIConfig();
            } else {
                //client has NOT configured KPIs
                this.toast.warning('You must configure your KPIs.');
            }
        });
    }

    setKPIScorecardsAssignedAndPositions() {
        this.clientKPIScorecards.forEach((clientScorecard) => {
            let assignedScorecard = this.kpiScorecards.find(
                (scorecard) => scorecard.kpiScorecardKey === clientScorecard.kpiScorecardKey
            );
            assignedScorecard.isAssigned = true;
            assignedScorecard.inActiveDate = clientScorecard.inActiveDate;
            assignedScorecard.effectiveDate = clientScorecard.activeDate;
            assignedScorecard.numKPIs
                ? (assignedScorecard.numKPIs = ++assignedScorecard.numKPIs)
                : (assignedScorecard.numKPIs = 1);
            assignedScorecard.positions = [];
        });
        this.clientKPIScorecardStaffPositions.forEach((position) => {
            let assignedScorecard = this.kpiScorecards.find(
                (scorecard) => scorecard.kpiScorecardKey === position.kpiScorecardKey
            );
            const checkedPosition = this.staffPositions.find(
                (p) => p.staffPositionKey === position.staffPositionKey
            ).position;
            this.checkedStaffPositions.add(checkedPosition);
            assignedScorecard?.positions?.push(checkedPosition);
        });
        this.staffPositions.forEach(
            (position) => (position.checked = this.checkedStaffPositions.has(position.position))
        );
        this.kpiScorecards.forEach((scorecard) => {
            if (
                scorecard.positions &&
                scorecard.positions.length &&
                scorecard.kpiScorecardType === 'Employee'
            ) {
                scorecard.positions.forEach((scorecardPosition) => {
                    let count =
                        this.positionMap.find(
                            (positionMap) => positionMap.position === scorecardPosition
                        )?.nbr ?? 0;
                    scorecard.numEmployees = count + (scorecard.numEmployees ?? 0);
                });
            } else if (scorecard.kpiScorecardType !== 'Employee') {
                let count =
                    this.positionMap.find(
                        (positionMap) => positionMap.position === scorecard.kpiScorecard
                    )?.nbr ?? 0;
                scorecard.numEmployees = count + (scorecard.numEmployees ?? 0);
            }
        });
    }

    refreshPageData() {
        this.resetKPIScorecardData();
        forkJoin(
            this.scorecardService.getClientKPIScorecards(),
            this.scorecardService.getClientKPIScorecardStaffPositions()
        ).subscribe(([kpis, positions]) => {
            if (kpis && kpis.length && positions && positions.length) {
                this.clientKPIScorecards = kpis;
                this.clientKPIScorecardStaffPositions = positions;
                this.setKPIScorecardsAssignedAndPositions();
            } else {
                this.toast.warning('Unexpected error retrieving page data.');
            }
        });
    }

    resetKPIScorecardData() {
        this.kpiScorecards.forEach((scorecard) => {
            scorecard.numKPIs = 0;
            scorecard.positions = [];
            scorecard.effectiveDate = null;
            scorecard.inActiveDate = null;
            scorecard.isAssigned = false;
            scorecard.numEmployees = undefined;
        });
    }

    onSubmit() {
        this.calculateTotalWeightPercentage();
        if (
            this.viewKPIScorecardProfile &&
            !this.scorecardListView &&
            !this.selectDatesAndPositions &&
            this.totalWeightPercentage === 100
        ) {
            //TODO: Simplify above if logic. One condition should be sufficient

            let params: IKPIScorecardChangeUpsertParams[] = [];
            this.changedProileData.forEach((change) => {
                params.push({
                    clientKPIKey: change.clientKPIKey ? change.clientKPIKey.toString() : '',
                    weight:
                        change.scorecardWeight !== null ? change.scorecardWeight.toString() : '',
                    isActive: change.isSelected === true ? '1' : '0',
                    kpiScoreCardKey: change.kpiScorecardKey
                        ? change.kpiScorecardKey.toString()
                        : '',
                });
            });
            this.loading = true;
            this.scorecardService.upsertKPIScorecardProfileChanges(params).subscribe(
                (res) => {
                    if (res >= 0) {
                        this.toast.success(
                            this.selectedKPIScorecard.kpiScorecard + ' scorecard profile saved.'
                        );
                        this.scorecardListView = true;
                        this.selectDatesAndPositions = false;
                        this.viewKPIScorecardProfile = false;
                        this.selectKPIs = this.setKPIWeights = this.viewKPIs = false;
                        this.changedProileData = [];
                        this.getKPIScorecardData();
                    } else {
                        this.toast.info('Please select a scorecard profile.');
                        this.loading = false;
                    }
                },
                (error) => {
                    this.toast.warning('Unexpected error saving positions.');
                    this.loading = false;
                }
            );
        }
    }

    savePositionChange() {
        let positionKeys = Array.from(this.selectedPositionKeys);

        this.loading = true;
        this.scorecardService
            .upsertKPIScorecard(
                this.selectedKPIScorecard.kpiScorecardKey,
                this.scorecardForm.getRawValue(),
                positionKeys as number[]
            )
            .subscribe(
                (r) => {
                    this.scorecardForm.reset();
                    this.selectedPositionKeys.clear();
                    this.loading = false;
                },
                () => {
                    this.toast.warning('Unexpected error.');
                    this.loading = false;
                }
            );
    }

    createFormGroup(): UntypedFormGroup {
        return this.formBuilder.group({
            effectiveDate: new UntypedFormControl(null, Validators.required),
            inactiveDate: new UntypedFormControl(null, Validators.required),
            selectedKPIs: this.formBuilder.array([], Validators.required),
        });
    }

    get effectiveDate() {
        return this.scorecardForm.get('effectiveDate');
    }

    get inactiveDate() {
        return this.scorecardForm.get('inactiveDate');
    }

    calculateTotalWeightPercentage() {
        this.footerObject = Object.assign({}, { footerSummary: [] });
        this.totalWeightPercentage = 0;
        this.scorecardInfoData.forEach((data) => {
            if (data.isSelected) {
                let weight = +data.scorecardWeight;
                if (Number.isNaN(weight)) {
                    weight = 0;
                }
                this.totalWeightPercentage += weight;
            }
        });

        this.footerObject = Object.assign(
            {},
            {
                footerSummary: [
                    {
                        fieldId: 'scorecardWeight',
                        aggregationType: 'sum',
                        value: this.totalWeightPercentage,
                    },
                ],
            }
        );
    }

    getClientKPICategory(clientKPI: ClientKPIWebModelComplete): any {
        let kpiMaster = this.kpiMasterList.find((kpi) => {
            return (
                kpi.kpiMasterKey === clientKPI.kpiMasterKey &&
                kpi.kpiMilestoneKey === clientKPI.kpiMilestoneKey &&
                kpi.kpiMilestoneStaffingKey === clientKPI.kpiMilestoneStaffingKey
            );
        });
        return kpiMaster.kpiCategory;
    }

    editScorecardClicked(i?: number) {
        if (i >= 0) {
            this.selectedKPIScorecard = this.gridView.data[i];
        }

        if (this.selectedKPIScorecard.isAssigned) {
            this.setPositionKeys();
            this.loadPositionNames();
            this.setDates();
        }
        scroll(0, 0);
        if (this.selectedKPIScorecard.kpiScorecardType !== 'Employee') {
            this.selectDatesAndPositions = false;
            this.viewScorecardClicked(this.selectedKPIScorecard);
            this.viewKPIScorecardProfile = true;
        } else {
            this.setPositionKeys();
            this.loadPositionNames();
            this.setDates();

            this.selectDatesAndPositions = true;
            this.viewKPIScorecardProfile = false;
        }
        this.scorecardListView = false;
    }

    editButtonCliecked() {
        this.searchTerm = '';
        this.selectKPIs = true;
        this.setKPIWeights = false;
        this.viewKPIs = false;
        this.totalWeightPercentage = 0;
        this.updateKPIGrid();
    }

    setProfileSelectColumnDisplayStatus() {
        let selectProfileColumn = this.columnInfoList.find((col) => col.fieldId === 'isSelected');
        if (selectProfileColumn) {
            selectProfileColumn.hidden = !this.selectKPIs;
        }
    }

    setProfileWeightColumnEditStatus(data: IScorecardKPIInfo[]) {
        let weightColumn = this.columnInfoList.find((col) => col.fieldId === 'scorecardWeight');

        if (weightColumn?.dataInputProperties?.disableKey) {
            data.map((dataRow) => {
                dataRow[weightColumn?.dataInputProperties?.disableKey] = !this.setKPIWeights;
            });
        }
    }

    updateKPIGrid() {
        this.profileTableDataProperties.isDataLoaded = false;
        this.profileTableDataProperties.hasData = false;
        let data: IScorecardKPIInfo[] = this.scorecardInfoData;
        this.setProfileSelectColumnDisplayStatus();

        if (this.viewKPIs || this.setKPIWeights) {
            data = this.scorecardInfoData.filter((item) => item.isSelected === true);
        }
        let columnProperties = this.profileTableColumnProperties.columnProperties;
        if (this.searchTerm && this.searchTerm.length > 0) {
            data = this.commKendoTbleService.searchHandler(data, columnProperties, this.searchTerm);
        }

        columnProperties.forEach((item) => {
            // TODO: set type / hidden status more dynamic
            if (this.viewKPIs && item.inputProperties) {
                item.dataType = 'number';
            } else {
                item.dataType = item.dataType;
            }

            if (this.viewKPIs && item.checkBoxProperties) {
                item.hidden = true;
            }

            if (this.selectKPIs && item.checkBoxProperties) {
                item.hidden = false;
            }

            if (this.selectKPIs && item.inputProperties) {
                item.dataType = 'number';
            }

            if (this.setKPIWeights && item.checkBoxProperties) {
                item.hidden = true;
            }
            item.hideFooterValue = true;
            if (this.setKPIWeights && item.inputProperties) {
                item.dataType = 'input';
                item.hideFooterValue = false;
            }
        });

        this.customTableInfo.dataSet = data;
        this.customTableInfo = this.reportService.refreshCustomMatTable(
            this.customTableInfo,
            true,
            true,
            this.action,
            this.searchTerm
        );

        this.profileTableColumnProperties = Object.assign({}, this.profileTableColumnProperties);
        this.profileTableDataProperties.gridData = data;
        this.profileTableDataProperties.hasData = data.length > 0;
        this.profileTableDataProperties.isDataLoaded = true;
        this.profileTableDataProperties = Object.assign({}, this.profileTableDataProperties);
    }

    setDates() {
        this.effectiveDate.setValue(
            this.reusableFunctions.getDateFromDateTimeOffset(
                this.selectedKPIScorecard.effectiveDate
            )
        );
        this.inactiveDate.setValue(
            this.reusableFunctions.getDateFromDateTimeOffset(this.selectedKPIScorecard.inActiveDate)
        );
    }

    setScorecardSelection() {
        this.scorecardInfoData.forEach((kpiInf) => {
            if (
                kpiInf.clientKPIScorecardKey &&
                kpiInf.clientKPIScorecardKey !== null &&
                kpiInf.isActive === true &&
                kpiInf.isDeleted === false
            ) {
                kpiInf.isSelected = true;
            } else {
                kpiInf.isSelected = false;
            }
        });
    }

    viewScorecardClicked(record: KPIScorecard) {
        scroll(0, 0);
        this.selectDatesAndPositions = false;
        this.scorecardListView = false;
        this.setKPIWeights = false;
        this.selectKPIs = false;
        this.viewKPIs = true;
        this.selectedKPIScorecard = record;
        this.searchTerm = '';

        this.profileTableDataProperties.gridData = [];
        this.resetTableData();
        this.scorecardService.getPossibleKPIsForScorecard(record.kpiScorecard).subscribe(
            (res) => {
                if (res && res.length > 0) {
                    this.scorecardInfoDataOriginal = this.kpiService.setScorecardInfoTableData(
                        res,
                        record.kpiScorecardKey
                    );
                    this.preserveOriginalKPIProfileData();
                    this.setScorecardSelection();
                    this.updateKPIGrid();
                } else {
                    this.profileTableDataProperties.gridData = [];
                    this.profileTableDataProperties.hasData = false;
                    this.profileTableDataProperties.isDataLoaded = true;
                    this.profileTableDataProperties = Object.assign(
                        {},
                        this.profileTableDataProperties
                    );
                }
            },
            (err) => {
                this.profileTableDataProperties.gridData = [];
                this.profileTableDataProperties.action = NoDataActionType.error;
                this.profileTableDataProperties.hasData = false;
                this.profileTableDataProperties.isDataLoaded = true;
                this.profileTableDataProperties = Object.assign(
                    {},
                    this.profileTableDataProperties
                );
                throw new Error(err);
            }
        );
        this.viewKPIScorecardProfile = true;
        this.calculateTotalWeightPercentage();
    }

    loadPositionNames() {
        this.selectedKPIScorecard.positions = this.staffPositions
            .filter((p) => this.selectedPositionKeys.has(p.staffPositionKey))
            .map((pos) => pos.position);
    }

    setPositionKeys() {
        this.selectedPositionKeys.clear();
        this.clientKPIScorecardStaffPositions.forEach((position) => {
            if (position.kpiScorecardKey === this.selectedKPIScorecard.kpiScorecardKey) {
                this.selectedPositionKeys.add(position.staffPositionKey);
            }
        });
    }

    onNext(record) {
        scroll(0, 0);
        this.searchTerm = '';
        if (this.selectDatesAndPositions) {
            this.loadPositionNames();
            this.setDates();
            this.selectDatesAndPositions = false;
            this.viewKPIScorecardProfile = true;
            this.viewScorecardClicked(record);
            this.viewKPIs = false;
            this.selectKPIs = true;
            this.savePositionChange();
        } else {
            this.setKPIWeights = true;
            this.selectKPIs = false;
            this.viewKPIs = false;
            this.updateKPIGrid();
            this.calculateTotalWeightPercentage();
        }
    }

    preserveOriginalKPIProfileData() {
        this.scorecardInfoData = this.scorecardInfoDataOriginal.map((obj) => ({ ...obj }));
    }

    cancelClicked() {
        scroll(0, 0);
        if (this.selectDatesAndPositions) {
            this.scorecardListView = true;
            this.selectDatesAndPositions = false;
            this.viewKPIScorecardProfile = false;
            this.getKPIScorecardData();
        } else {
            this.setKPIWeights = false;
            this.selectKPIs = false;
            this.viewKPIs = true;
            this.changedProileData = [];
            this.preserveOriginalKPIProfileData();
            this.setScorecardSelection();
            this.updateKPIGrid();
        }
    }

    returnToKpiProfilesClicked() {
        this.viewKPIScorecardProfile = false;
        this.selectKPIs = false;
        this.selectDatesAndPositions = false;
        this.viewKPIScorecardProfile = false;

        this.updateSummaryGrid();

        this.scorecardListView = true;
        this.setKPIWeights = false;
        this.selectedPositionKeys.clear();
    }

    backToPositions() {
        //Non EMployee types do no set positions
        if (this.selectedKPIScorecard.kpiScorecardType !== 'Employee') {
            this.scorecardListView = true;
        } else {
            this.selectDatesAndPositions = true;
        }
        this.viewKPIScorecardProfile = false;

        scroll(0, 0);
    }

    backToSelectKPIs() {
        this.searchTerm = '';
        this.setKPIWeights = false;
        this.selectKPIs = true;
        this.viewKPIs = false;
        scroll(0, 0);
        this.updateKPIGrid();
    }

    positionCheckboxChangeHandler(checked: boolean, positionKey: number) {
        const selectedStaffPosition = this.staffPositions.find(
            (position) => position.staffPositionKey === positionKey
        );
        this.scorecardForm.markAsDirty();
        if (!checked) {
            this.selectedPositionKeys.add(positionKey);
        } else {
            this.selectedPositionKeys.delete(positionKey);
        }
        selectedStaffPosition.checked = !checked;
    }

    updateSelectedPosition(checked: boolean, staffPositionKey: number) {
        if (checked) {
            this.selectedPositionKeys.add(staffPositionKey);
        } else {
            this.selectedPositionKeys.delete(staffPositionKey);
        }
        this.positionCheckboxChangeHandler(checked, staffPositionKey);
    }

    sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.gridView = {
            data: orderBy(this.gridView.data, this.sort),
            total: this.gridView.data.length,
        };
    }

    profileInputChangeEvent(event: ICellClickEventInfo) {
        let cellData = event.cellData as IScorecardKPIInfo;
        let colInfo = event.columnInfo;
        this.calculateTotalWeightPercentage();

        this.changedProileData = this.changedProileData.filter(
            (item) => item.clientKPIKey != cellData.clientKPIKey
        );
        this.changedProileData.push(cellData);
    }

    profileContentChangeEvent(event: IScorecardKPIInfo[]) {
        this.setProfileWeightColumnEditStatus(event);
    }

    searchRows(searchTerm) {
        this.searchTerm = searchTerm;
        let timeout = null;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            this.noDataType.action = NoDataActionType.search;
            this.noDataType.searchTerm = this.searchTerm;
            this.updateKPIGrid();
        }, 1000);
    }

    getHeaderStyle() {
        return {
            'background-color': '#FFFFFF',
            color: '#223540',
            'border-width': '0 0 medium 0',
            font: 'Bold 14px/19px Roboto',
        };
    }

    resetTableData() {
        let customTableInfo = Object.assign({}, this.customTableInfo);
        customTableInfo.dataSet = [];
        return this.reportService.refreshCustomMatTable(
            customTableInfo,
            false,
            false,
            this.action,
            this.searchTerm
        );
    }
}
